<template>
    <div>
        <b-breadcrumb>
            <b-breadcrumb-item to="/">
                <i class="fa fa-home"></i>
                Home
            </b-breadcrumb-item>
            <b-breadcrumb-item to="/FinancialServices/IDTs">
              Financial Services
            </b-breadcrumb-item>
            <b-breadcrumb-item to="/FinancialServices/Leases">Computer Leases</b-breadcrumb-item>
            <b-breadcrumb-item active>Edit</b-breadcrumb-item>
        </b-breadcrumb>

        <form @submit.prevent="onSubmit()">
            <div class="card">
                <div class="bg-dark card-header text-white">Edit Computer Lease</div>
                <div v-if="!isLoading && billingAccounts.length > 0 && lessees.length > 0" class="card-body">
                    <b-container>
                        <b-row>
                            <b-col>
                                <div class="font-weight-bold">Asset Number</div>
                                <div class="pl-4">{{ computerLease.assetNumber }}</div>
                            </b-col>
                            <b-col>
                                <div class="font-weight-bold">Serial Number</div>
                                <div class="pl-4">{{ computerLease.serialNumber }}</div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <div class="font-weight-bold">Manufacturer</div>
                                <div class="pl-4">{{ computerLease.manufacturer }}</div>
                            </b-col>
                            <b-col>
                                <div class="font-weight-bold">Model Number</div>
                                <div class="pl-4">{{ computerLease.modelNumber }}</div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <div class="font-weight-bold">Description</div>
                                <div class="pl-4">{{ computerLease.description }}</div>
                            </b-col>
                            <b-col>
                                <div class="font-weight-bold">Vendor</div>
                                <div class="pl-4">{{ computerLease.vendor }}</div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <div class="font-weight-bold">Purchase Amount</div>
                                <div class="pl-4">{{ computerLease.purchaseAmount }}</div>
                            </b-col>
                            <b-col>
                                <div class="font-weight-bold">Purchase Date</div>
                                <div class="pl-4">{{ computerLease.purchaseDate | moment('MM/DD/YYYY') }}</div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <div class="font-weight-bold">Custodian</div>
                                <div class="pl-4">{{ computerLease.custodianPersonName }}</div>
                            </b-col>
                            <b-col>
                                <div class="font-weight-bold">Warranty Period</div>
                                <div class="pl-4">{{ computerLease.warrantyStartDate | moment('MM/DD/YYYY') }}{{ (computerLease.warrantyStartDate !== null && computerLease.warrantyEndDate !== null) || (computerLease.warrantyStartDate === null && computerLease.warrantyEndDate === null) ? ' - ' : '' }}{{ computerLease.warrantyEndDate | moment('MM/DD/YYYY') }}</div>
                            </b-col>
                        </b-row>
                    </b-container>

                    <br />

                    <div class="card">
                        <div class="card-header">
                            <ul class="card-header-tabs nav nav-tabs">
                                <li class="nav-item">
                                    <a @click="currentTabComponent='Details'" class="active nav-link"
                                      data-toggle="tab"
                                      role="tab"
                                      aria-controls="details"
                                      type="button"
                                      data-target="#details">Details</a>
                                </li>
                                <li class="nav-item">
                                    <a @click="currentTabComponent='Billing'" class="nav-link"
                                      data-toggle="tab"
                                      role="tab"
                                      aria-controls="billing"
                                      type="button"
                                      data-target="#billing">Billing</a>
                                </li>
                            </ul>
                        </div>
                        <div class="tab-content">
                            <div class="tab-pane active" id="details" role="tabpanel" aria-labelledby="details-tab">
                                <br />
                                <b-container>
                                  <b-row>
                                      <b-col class="text-center">
                                          <div class="font-weight-bold">Lease Start Date</div>
                                          <div>{{ computerLease.leaseStartDate | moment('MM/DD/YYYY') }}</div>
                                      </b-col>
                                      <b-col class="text-center">
                                          <div class="font-weight-bold">Lease End Date</div>
                                          <b-input-group class="mb-3">
                                            <b-form-input :state="$v.computerLease.leaseEndDate.$invalid && isValidating ? false : null"
                                              v-model="tempLeaseEndDate"
                                              type="text"
                                              placeholder="MM/DD/YYYY"
                                              autocomplete="off"
                                              @change="updateLeaseEndDateFromInput()"
                                            ></b-form-input>
                                            <b-input-group-append>
                                              <b-form-datepicker
                                                id="leaseEndDate"
                                                v-model="computerLease.leaseEndDate"
                                                button-only
                                                right
                                                locale="en-US"
                                                aria-controls="leaseEndDate"
                                                :min="computerLease.leaseStartDate"
                                                @context="updateLeaseEndDateFromButton()"
                                              ></b-form-datepicker>
                                            </b-input-group-append>
                                          </b-input-group>
                                          <div v-if="!$v.computerLease.leaseEndDate.valueCheck && isValidating" class="col-12 invalid-feedback" style="display: block;">
                                              End date must occur on or after start date
                                          </div>
                                      </b-col>
                                      <b-col col lg="2" md="3" class="form-group">
                                          <label for="leaseRate">Monthly Lease Rate</label>
                                          <input class="form-control"
                                                  v-model="computerLease.leaseRate"/>
                                      </b-col>
                                      <b-col class="align-self-center">
                                          <button @click.prevent="setDefaultLeaseRate()" class="btn btn-secondary d-print-none">
                                            Calculate Defaults
                                          </button>
                                      </b-col>
                                      <b-col class="text-center">
                                          <label>Months Left on Lease</label>
                                          <div>{{monthsLeftOnLease}}</div>
                                      </b-col>
                                  </b-row>
                                  <b-row>
                                    <b-col class="text-center">
                                          <div class="font-weight-bold">Warranty Start Date</div>
                                          <b-input-group class="mb-3">
                                            <b-form-input :state="$v.computerLease.warrantyStartDate.$invalid && isValidating ? false : null"
                                              v-model="tempWarrantyStartDate"
                                              type="text"
                                              placeholder="MM/DD/YYYY"
                                              autocomplete="off"
                                              @change="updateWarrantyStartDateFromInput()"
                                            ></b-form-input>
                                            <b-input-group-append>
                                              <b-form-datepicker
                                                id="warrantyStartDate"
                                                v-model="computerLease.warrantyStartDate"
                                                button-only
                                                right
                                                locale="en-US"
                                                aria-controls="warrantyStartDate"
                                                @context="updateWarrantyStartDateFromButton()"
                                              ></b-form-datepicker>
                                            </b-input-group-append>
                                          </b-input-group>
                                          <div v-if="!$v.computerLease.warrantyStartDate.valueCheck && isValidating" class="col-12 invalid-feedback" style="display: block;">
                                              Start date must occur on or before end date
                                          </div>
                                      </b-col>
                                      <b-col class="text-center">
                                          <div class="font-weight-bold">Warranty End Date</div>
                                          <b-input-group class="mb-3">
                                            <b-form-input :state="$v.computerLease.warrantyEndDate.$invalid && isValidating ? false : null"
                                              v-model="tempWarrantyEndDate"
                                              type="text"
                                              placeholder="MM/DD/YYYY"
                                              autocomplete="off"
                                              @change="updateWarrantyEndDateFromInput()"
                                            ></b-form-input>
                                            <b-input-group-append>
                                              <b-form-datepicker
                                                id="warrantyEndDate"
                                                v-model="computerLease.warrantyEndDate"
                                                button-only
                                                right
                                                locale="en-US"
                                                aria-controls="warrantyEndDate"
                                                :min="computerLease.warrantyStartDate"
                                                @context="updateWarrantyEndDateFromButton()"
                                              ></b-form-datepicker>
                                            </b-input-group-append>
                                          </b-input-group>
                                          <div v-if="!$v.computerLease.warrantyEndDate.valueCheck && isValidating" class="col-12 invalid-feedback" style="display: block;">
                                              End date must occur on or after start date
                                          </div>
                                      </b-col>
                                  </b-row>
                                  <b-row>
                                      <b-col col lg="6" md="12" class="form-group">
                                          <label for="lesseePersonId">Lessee</label>
                                          <select class="form-control" v-model="computerLease.lesseePersonId">
                                              <option :value="null" disabled>--Select Person--</option>
                                              <option :key="lessee.id" :value="lessee.id" v-for="lessee in lessees">{{lessee.name}}</option>
                                          </select>
                                      </b-col>
                                  </b-row>
                                  <b-row>
                                      <b-col class="form-group">
                                          <label for="notes">Notes</label>
                                          <b-form-textarea 
                                            size="sm"
                                            v-model="computerLease.notes"
                                          ></b-form-textarea>
                                      </b-col>
                                  </b-row>
                                </b-container>
                            </div>
                            <div class="tab-pane" id="billing" role="tabpanel" aria-labelledby="billing-tab">
                                <br />

                                <b-container>
                                    <b-row class="row">
                                        <b-col col lg="3" md="4" class="form-group">
                                            <label for="billingAccountId">Billing Account</label>
                                            <select :class="{'is-invalid': $v.computerLease.leasePurchaseAccountId.$invalid && isValidating}"
                                                    class="form-control" v-model="computerLease.leasePurchaseAccountId">
                                                <option :value="null" disabled>--Select Account--</option>
                                                <option :key="billingAccount.id" :value="billingAccount.id" v-for="billingAccount in billingAccounts">{{billingAccount.sl}}-{{billingAccount.sa}}</option>
                                            </select>
                                            <span v-if="!$v.computerLease.leasePurchaseAccountId.required && isValidating" class="invalid-feedback">
                                                Field is required
                                            </span>
                                        </b-col>
                                        <b-col class="align-self-center">
                                            <b-form-checkbox
                                                v-model="computerLease.isSpecialProjectRequest"
                                                :value="true"
                                                :unchecked-value="false"
                                                @change="clearValues($event)"
                                              >
                                                Bill to Different Account(s)
                                            </b-form-checkbox>
                                        </b-col>
                                    </b-row>
                                    <template v-if="computerLease.isSpecialProjectRequest">
                                        <b-row>
                                            <b-col>
                                                <div class="text-right pb-2">
                                                    <button @click="addSpecialProjectRequest" type="button" class="btn btn-success">
                                                        <i class="fa fa-plus"></i>Add
                                                    </button>
                                                </div>
                                                <AppNotification type="danger" v-if="totalSpecialProjectRequestsPercentage > 100 && isValidating">
                                                    Total percentage cannot exceed 100. Please adjust the percentages
                                                </AppNotification>
                                                <AppNotification type="danger" v-if="!(totalSpecialProjectRequestsPercentage > 100) && totalSpecialProjectRequestsPercentage !== 100 && numberOfSpecialProjectRequests !== 0 && isValidating">
                                                    Total percentage must equal 100. Please adjust the percentages
                                                </AppNotification>
                                                <AppNotification type="danger" v-if="!$v.computerLease.specialProjectRequests.required && isValidating">
                                                    At least one account must be added
                                                </AppNotification>
                                                <BTable :busy="isLoading"
                                                        :fields="tableFields"
                                                        :items="computerLease.specialProjectRequests"
                                                        :responsive="true"
                                                        primary-key="accountId"
                                                        show-empty
                                                        table-class="table-align-middle">
                                                    <template v-slot:cell(accountId)="row">
                                                        <button @click="removeSpecialProjectRequest(row.index)" type="button" class="btn btn-danger">
                                                            <i class="fa fa-trash"></i>Delete
                                                        </button>
                                                    </template>
                                                    <template v-slot:cell(accountNumber)="row">
                                                        <select class="form-control" v-model="row.item.accountId" 
                                                                                     :class="{'is-invalid': $v.computerLease.specialProjectRequests.$each[row.index].accountId.$invalid && isValidating}">
                                                            <option :value="null" disabled>--Select Account--</option>
                                                            <option :key="billingAccount.id" :value="billingAccount.id" v-for="billingAccount in billingAccounts">{{billingAccount.sl}}-{{billingAccount.sa}}</option>
                                                        </select>
                                                        <span class="invalid-feedback" v-if="!$v.computerLease.specialProjectRequests.$each[row.index].accountId.required && isValidating">Field is required</span>
                                                    </template>
                                                    <template v-slot:cell(percentageSplit)="row">
                                                        <input class="form-control" type="number" v-model="row.item.percentageSplit" :class="{'is-invalid': $v.computerLease.specialProjectRequests.$each[row.index].percentageSplit.$invalid && isValidating}" />
                                                        <span class="invalid-feedback" v-if="!$v.computerLease.specialProjectRequests.$each[row.index].percentageSplit.required && isValidating">Field is required</span>
                                                        <span class="invalid-feedback" v-if="!$v.computerLease.specialProjectRequests.$each[row.index].percentageSplit.valueCheck && isValidating">Value must be greater than 0</span>
                                                    </template>

                                                    <!-- Footer -->
                                                    <template v-slot:custom-foot>
                                                        <b-tr>
                                                            <b-td class="text-right" :colspan="tableFields.length">
                                                                <span class="font-weight-bold">Total Percentage: {{totalSpecialProjectRequestsPercentage}} </span>                                                      
                                                            </b-td>
                                                        </b-tr>
                                                    </template>
                                                </BTable>
                                            </b-col>
                                        </b-row>
                                    </template>
                                </b-container>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer d-print-none text-right">
                    <button :disabled="isSubmitting" class="btn btn-primary" type="submit">Save</button>
                    <RouterLink :to="{name:'ComputerLeases'}" class="btn btn-danger">Back</RouterLink>
                </div>
            </div>
        </form>

    </div>
</template>

<script>
    import AppNotification from "@/components/shared/AppNotification";
    import {ToastType} from "@/services/models/shared/ToastType";
    import {required, requiredIf} from "vuelidate/lib/validators";
    import ComputersService from "@/services/ComputersService";
    import AccountsService from "@/services/AccountsService";
    import PersonService from "@/services/PersonService";

    export default {
        components: {
          AppNotification
        },
        props: {
            id: {
              type: String,
              required: true
            }
        },
        data() {
            return {
                isLoading: true,
                billingAccounts: [],
                lessees: [],
                isSubmitting: false,
                isValidating: false,
                computerLease: {
                  leasePurchaseAccountId: null,
                  isSpecialProjectRequest: false,
                  specialProjectRequests: null,
                  leaseRate: null,
                  lesseePersonId: null,
                  warrantyStartDate: null,
                  warrantyEndDate: null,
                  notes: null,
                  leaseEndDate: null
                },
                currentTab: 'Details',
                tableFields: [
                    {
                        key: 'accountId',
                        label: '',
                        thStyle: 'width:200px'
                    }, 
                    {
                        key: 'accountNumber',
                        label: 'SL-SA'
                    },
                    {
                        key: 'percentageSplit',
                        label: 'Percentage Split'
                    }
                ],
                tempLeaseEndDate: null,
                tempWarrantyStartDate: null,
                tempWarrantyEndDate: null
            }
        },
        watch: {
            'computerLease.warrantyStartDate' () {
                if (this.computerLease.warrantyStartDate !== null) {
                    this.computerLease.warrantyEndDate = this.$moment(this.computerLease.warrantyStartDate).add(3, 'y').toDate();
                }
            }
        },
        computed: {
            monthsLeftOnLease () {
                if (this.computerLease.leaseStartDate !== null 
                    && this.computerLease.leaseEndDate !== null) {
                    const startDate = new Date();
                    const endDate = new Date(this.computerLease.leaseEndDate);
                    startDate.setDate(1);
                    let retVal = endDate.getMonth() - startDate.getMonth() + 12 * (endDate.getFullYear() - startDate.getFullYear());

                    if (endDate.getDate() !== 1) {
                      retVal += 1;
                    }


                    return retVal;
                }

                return 0;
            },

            totalSpecialProjectRequestsPercentage () {
                if (this.computerLease.specialProjectRequests.length === 0 || this.computerLease.specialProjectRequests === null) {
                  return 0
                }
                return this.computerLease.specialProjectRequests.reduce((accum,item) => parseFloat(accum) + parseFloat(item.percentageSplit === null || item.percentageSplit.toString().trim() === '' ? '0' : item.percentageSplit), 0)
            },

            numberOfSpecialProjectRequests () {
              return this.computerLease.specialProjectRequests !== null ? this.computerLease.specialProjectRequests.length : 0
            }
        },
        methods: {
            /**
             * @description Updates a computer lease and redirects if successful
             */
            onSubmit() {
                const vm = this;
                vm.isValidating = true;

                // stop here if form is invalid
                this.$v.$touch();
                if (this.$v.$invalid || (this.computerLease.isSpecialProjectRequest && this.totalSpecialProjectRequestsPercentage !== 100)) {
                    return;
                }

                vm.isSubmitting = true;

                ComputersService.updateComputerLease(this.id, {
                    leasePurchaseAccountId: this.computerLease.leasePurchaseAccountId,
                    isSpecialProjectRequest: this.computerLease.isSpecialProjectRequest,
                    specialProjectRequests: this.computerLease.specialProjectRequests,
                    leaseRate: this.computerLease.leaseRate,
                    lesseePersonId: this.computerLease.lesseePersonId,
                    notes: this.computerLease.notes,
                    leaseEndDate: this.computerLease.leaseEndDate,
                    warrantyStartDate: this.computerLease.warrantyStartDate,
                    warrantyEndDate: this.computerLease.warrantyEndDate
                })
                    .then(response => {
                      vm.alert(ToastType.Success, "The computer lease was successfully updated");
                      vm.$router.replace({name:'ComputerLeases'})
                    })
                    .catch((error) => {
                      vm.alert(ToastType.Danger, error.response.data)
                    })
                    .finally(() => {
                      vm.isValidating = false;
                      vm.isSubmitting = false;
                    })
            },

            loadComputerLease () {
              const vm = this;

              this.isLoading = true;

              ComputersService.getComputerLease(this.id)
                  .then(response => {
                      vm.computerLease = response;
                      vm.tempLeaseEndDate = this.$moment(response.leaseEndDate).format("MM/DD/YYYY");
                      vm.tempWarrantyStartDate = this.$moment(response.warrantyStartDate).format("MM/DD/YYYY");
                      vm.tempWarrantyEndDate = this.$moment(response.warrantyEndDate).format("MM/DD/YYYY");
                  })
                  .catch(error => {
                      vm.alert(ToastType.Danger, error.response.data)
                  })
                  .finally(() => {
                      vm.isLoading = false;
                  })
            },

            loadAccounts () {
              const vm = this;

              AccountsService.getAccounts({
                returnAll: true,
                page: 1,
                pageSize: 10,
                isDeleted: false,
              })
                  .then(response => {
                      vm.billingAccounts = response.data;
                  })
                  .catch(error => {
                      vm.alert(ToastType.Danger, error.response.data)
                  })
            },

            loadLessees () {
              const vm = this;

              PersonService.getPeopleList({
                page: 1,
                pageSize: 10,
                name: null,
                uin: null,
                organizationCode: null,
                onlyShowActive: true,
                onlyShowTTI: true,
                onlyShowMissingAddress: false,
                returnAll: true
              })
                  .then(response => {
                      vm.lessees = response.data;
                  })
                  .catch(error => {
                      vm.alert(ToastType.Danger, error.response.data)
                  })
            },

            setDefaultLeaseRate () {
                if (this.monthsLeftOnLease > 0) {
                    this.computerLease.leaseRate = Math.round((Number(this.computerLease.purchaseAmount / this.monthsLeftOnLease) + Number.EPSILON) * 100) / 100
                } else {
                    this.computerLease.leaseRate = 0
                }
            },

            addSpecialProjectRequest () {
              this.computerLease.specialProjectRequests.push({
                  accountId: null,
                  accountNumber: null,
                  percentageSplit: 0
              });
            },

            removeSpecialProjectRequest (index) {
              this.computerLease.specialProjectRequests.splice(index, 1);
            },

            clearValues (val) {
                if (!val) {
                  this.computerLease.specialProjectRequests = []
                }
            },

            updateLeaseEndDateFromInput () {
                if (this.tempLeaseEndDate !== null) {
                  this.computerLease.leaseEndDate = this.$moment(this.tempLeaseEndDate, "MM/DD/YYYY").toDate()
                }
            },

            updateLeaseEndDateFromButton () {
                if (this.computerLease.leaseEndDate !== null) {
                  this.tempLeaseEndDate = this.$moment(this.computerLease.leaseEndDate).format("MM/DD/YYYY")
                }
            },

            updateWarrantyStartDateFromInput () {
                if (this.tempWarrantyStartDate !== null) {
                  this.computerLease.warrantyStartDate = this.$moment(this.tempWarrantyStartDate, "MM/DD/YYYY").toDate()
                }
            },

            updateWarrantyStartDateFromButton () {
                if (this.computerLease.warrantyStartDate !== null) {
                  this.tempWarrantyStartDate = this.$moment(this.computerLease.warrantyStartDate).format("MM/DD/YYYY")
                }
            },

            updateWarrantyEndDateFromInput () {
                if (this.tempWarrantyEndDate !== null) {
                  this.computerLease.warrantyEndDate = this.$moment(this.tempWarrantyEndDate, "MM/DD/YYYY").toDate()
                }
            },

            updateWarrantyEndDateFromButton () {
                if (this.computerLease.warrantyEndDate !== null) {
                  this.tempWarrantyEndDate = this.$moment(this.computerLease.warrantyEndDate).format("MM/DD/YYYY")
                }
            }
        },
        validations: {
            computerLease: {
              leasePurchaseAccountId: {
                required
              },
              specialProjectRequests: {
                required: requiredIf (function () {
                  return this.computerLease.isSpecialProjectRequest
                }),
                $each: {
                  accountId: {
                    required
                  },
                  percentageSplit: {
                    required,
                    valueCheck (val) {
                      return val !== null && val > 0
                    }
                  }
                }
              },
              leaseEndDate: {
                required: requiredIf(function (value) {
                  return value.leaseEndDate !== null
                }),
                valueCheck() {
                  if (this.computerLease.leaseStartDate !== null && this.computerLease.leaseEndDate !== null) {
                    if (this.computerLease.leaseStartDate === this.computerLease.leaseEndDate) {
                      return false
                    }
                    return (new Date(this.computerLease.leaseEndDate)).getFullYear() > (new Date(this.computerLease.leaseStartDate)).getFullYear()
                      || ((new Date(this.computerLease.leaseEndDate)).getFullYear() === (new Date(this.computerLease.leaseStartDate)).getFullYear()
                          && (new Date(this.computerLease.leaseEndDate)).getMonth() > (new Date(this.computerLease.leaseStartDate)).getMonth())
                      || ((new Date(this.computerLease.leaseEndDate)).getFullYear() === (new Date(this.computerLease.leaseStartDate)).getFullYear()
                          && (new Date(this.computerLease.leaseEndDate)).getMonth() === (new Date(this.computerLease.leaseStartDate)).getMonth()
                          && (new Date(this.computerLease.leaseEndDate)).getDate() > (new Date(this.computerLease.leaseStartDate)).getDate())
                      || ((new Date(this.computerLease.leaseEndDate)).getFullYear() === (new Date(this.computerLease.leaseStartDate)).getFullYear()
                          && (new Date(this.computerLease.leaseEndDate)).getMonth() === (new Date(this.computerLease.leaseStartDate)).getMonth()
                          && (new Date(this.computerLease.leaseEndDate)).getDate() === (new Date(this.computerLease.leaseStartDate)).getDate())
                  }
                  return true
                }
              },
              warrantyStartDate: {
                required: requiredIf(function (value) {
                  return value.warrantyStartDate !== null
                }),
                valueCheck() {
                  if (this.computerLease.warrantyStartDate !== null && this.computerLease.warrantyEndDate !== null) {
                    if (this.computerLease.warrantyStartDate === this.computerLease.warrantyEndDate) {
                      return false
                    }
                    return (new Date(this.computerLease.warrantyEndDate)).getFullYear() > (new Date(this.computerLease.warrantyStartDate)).getFullYear()
                      || ((new Date(this.computerLease.warrantyEndDate)).getFullYear() === (new Date(this.computerLease.warrantyStartDate)).getFullYear()
                          && (new Date(this.computerLease.warrantyEndDate)).getMonth() > (new Date(this.computerLease.warrantyStartDate)).getMonth())
                      || ((new Date(this.computerLease.warrantyEndDate)).getFullYear() === (new Date(this.computerLease.warrantyStartDate)).getFullYear()
                          && (new Date(this.computerLease.warrantyEndDate)).getMonth() === (new Date(this.computerLease.warrantyStartDate)).getMonth()
                          && (new Date(this.computerLease.warrantyEndDate)).getDate() > (new Date(this.computerLease.warrantyStartDate)).getDate())
                      || ((new Date(this.computerLease.warrantyEndDate)).getFullYear() === (new Date(this.computerLease.warrantyStartDate)).getFullYear()
                          && (new Date(this.computerLease.warrantyEndDate)).getMonth() === (new Date(this.computerLease.warrantyStartDate)).getMonth()
                          && (new Date(this.computerLease.warrantyEndDate)).getDate() === (new Date(this.computerLease.warrantyStartDate)).getDate())
                  }
                  return true
                }
              },
              warrantyEndDate: {
                required: requiredIf(function (value) {
                  return value.warrantyEndDate !== null
                }),
                valueCheck() {
                  if (this.computerLease.warrantyStartDate !== null && this.computerLease.warrantyEndDate !== null) {
                    if (this.computerLease.warrantyStartDate === this.computerLease.warrantyEndDate) {
                      return false
                    }
                    return (new Date(this.computerLease.warrantyEndDate)).getFullYear() > (new Date(this.computerLease.warrantyStartDate)).getFullYear()
                      || ((new Date(this.computerLease.warrantyEndDate)).getFullYear() === (new Date(this.computerLease.warrantyStartDate)).getFullYear()
                          && (new Date(this.computerLease.warrantyEndDate)).getMonth() > (new Date(this.computerLease.warrantyStartDate)).getMonth())
                      || ((new Date(this.computerLease.warrantyEndDate)).getFullYear() === (new Date(this.computerLease.warrantyStartDate)).getFullYear()
                          && (new Date(this.computerLease.warrantyEndDate)).getMonth() === (new Date(this.computerLease.warrantyStartDate)).getMonth()
                          && (new Date(this.computerLease.warrantyEndDate)).getDate() > (new Date(this.computerLease.warrantyStartDate)).getDate())
                      || ((new Date(this.computerLease.warrantyEndDate)).getFullYear() === (new Date(this.computerLease.warrantyStartDate)).getFullYear()
                          && (new Date(this.computerLease.warrantyEndDate)).getMonth() === (new Date(this.computerLease.warrantyStartDate)).getMonth()
                          && (new Date(this.computerLease.warrantyEndDate)).getDate() === (new Date(this.computerLease.warrantyStartDate)).getDate())
                  }
                  return true
                }
              }
            }
        },
        created () {
          this.loadAccounts();
          this.loadLessees();
          this.loadComputerLease(this.id);
        }
    }
</script>
